import { FILTERS_NAMES_CONST } from "@/modules/GeneralRules/constants/GeneralRulesConstants";

export const RECIPIENTS = {
  LABELS: {
    DEFAULT_RECIPIENTS: "Seleccionar usuarios predefinidos",
    FILTER_BY_DEPENDENCY: "Filtrar por dependencia",
    FILTER_USERS_BY_TEMPLATE: "Filtrar usuarios por plantilla"
  },
  EVENTS: {
    UPDATE_DEFAULT: "updateDefault",
    UPDATE_DEPENDENCIES: "updateDependencies",
    UPDATE_DEPENDENCY_USERS: "updateDependencyUsers",
    UPDATE_MULTIPLE_RECIPIENTS: "updateMultipleRecipients",
    MAPPED: "recipientsConfigMapped"
  },
  EMPTY: {
    USERS_DEP: "No se encontraron usuarios de las dependencias seleccionadas",
    DEPENDENCIES: "No se encontraron dependencias"
  }
};
export const EDITING_RECIPIENTS = {
  DEPENDENCY_USERS: "dependencyUsers",
  TEMPLATE_USERS: "templateUsers",
  USER_TEMPLATES: "userTemplates",
  DEPENDENCIES: "dependencies"
};

export const DEFAULT_USER = {
  param: "user",
  name: "Usuario asociado"
};

export const DEFAULT_USER_CUSTOM = {
  id: "user",
  name: "Usuario asociado"
};

export const DEFAULT_RECIPIENTS_KEYS = {
  CHANGED_BY: "changedBy",
  CREATED_BY: "createdBy",
  USER: "user",
  ATTENDED_BY: "attendedBy"
};

export const DEFAULT_RECIPIENTS = [
  {
    param: DEFAULT_RECIPIENTS_KEYS.CHANGED_BY,
    name: "Editor registro"
  },
  {
    param: DEFAULT_RECIPIENTS_KEYS.CREATED_BY,
    name: "Creador registro"
  },
  {
    param: DEFAULT_RECIPIENTS_KEYS.USER,
    name: "Usuario asociado"
  }
];
export const TASKS_RULES_RECIPIENTS = [
  {
    param: DEFAULT_RECIPIENTS_KEYS.CHANGED_BY,
    name: "Editor registro"
  },
  {
    param: DEFAULT_RECIPIENTS_KEYS.CREATED_BY,
    name: "Creador registro"
  }
];

export const DEFAULT_EXTENDED_RECIPIENTS = [
  {
    param: DEFAULT_RECIPIENTS_KEYS.CHANGED_BY,
    name: "Editor registro"
  },
  {
    param: DEFAULT_RECIPIENTS_KEYS.CREATED_BY,
    name: "Creador registro"
  },
  {
    param: DEFAULT_RECIPIENTS_KEYS.USER,
    name: "Usuario asociado"
  },
  {
    param: DEFAULT_RECIPIENTS_KEYS.ATTENDED_BY,
    name: "Responsable"
  }
];

export const ATTENDEDBY_COLLECTIONS = [
  FILTERS_NAMES_CONST.SERVICE.NAME,
  FILTERS_NAMES_CONST.SESSION.NAME,
  FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.NAME
];
